import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ArrowIcon from '../components/img/right-arrow.png';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";

const Articles = () => {
    const { id } = useParams(); // Get the article ID from the URL
    const [article, setArticle] = useState(null);
    const [moreArticles, setMoreArticle] = useState([]);
    const navigate = useNavigate(); // Initialize useNavigate
    
  
    useEffect(() => {
		axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/articles.php?id=${id}`)
			.then(response => {
			setArticle(response.data);
			})
			.catch(error => {
			console.error("There was an error fetching the article!", error);
			});
    }, [id]); 
  
    useEffect(() => {
		// Fetch articles
		axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_latest_articles.php')
			.then(response => {
			setMoreArticle(response.data);
			})
			.catch(error => {
			console.error("There was an error fetching the articles!", error);
			});
    }, []);

    const handleArticleClick = (articleId) => {
      navigate(`/article/${articleId}`); // Use navigate to redirect
    };

    return (
        <div>
            {moreArticles.map(article => (
                <div className="post-row">
                    <span className="post-titles" onClick={() => handleArticleClick(article.id)}>{article.title}</span>
                    <p className='post-link' onClick={() => handleArticleClick(article.id)}> <FaArrowRightLong /> </p>
                    {/* <div className='post-arow-div' >
                        <img className="post-arow" src={ArrowIcon} alt="Arrow Icon" />
                    </div> */}
                </div>
            ))}
        </div>
    );
};

export default Articles;